export default function ErrorState({
  message,
  onRetry,
}: {
  message: string
  onRetry?: () => void
}) {
  return (
    <div className="rounded border border-error bg-bg-secondary px-4 py-4 text-sm text-error">
      <p>{message}</p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-2 rounded border border-error px-3 py-1 text-xs font-medium text-error hover:bg-error hover:text-white"
        >
          Retry
        </button>
      )}
    </div>
  )
}
